<template>
  <div class="wrapper">

    <CModal
            :title="title"
            size="lg"
            :closeOnBackdrop=false
            :show.sync="successModal"
    >


      <component :is="show_component"></component>
      <template #footer>
        <CButton @click="modal_close()" color="primary">{{$t('buttons.cancel')}}</CButton>
      </template>
    </CModal>



  </div>

</template>

<script>
  import {bus} from '../../../main';

  export default {
    name: 'Modals',
    components:{
      'category': () => import('../base/Categories'),
      'brand': () => import('../base/Brands'),
      'main_group': () => import('../base/ProductNatures'),
      'unit': () => import('../base/ProductUnits'),
      'delivery_costs': () => import('../settings/DeliveryCosts'),
      'add_area': () => import('../base/Areas'),

    },
    data() {
      return {

        successModal: false,
        show_component: '',


        title: '',
        message_api: '',
          message: '',
          message_confirm: '',

          buttons: [],
        buttons_onclick: [],
      }
    },

    mounted() {
          bus.$on('show_add_base_modal', (data) => {
              // alert(data);
            // var json = JSON.parse(data);
            this.show_component = data;
            this.successModal = true;

          });
          bus.$on('close_add_base_modal', (data) => {
              // alert(data);
            // var json = JSON.parse(data);
            this.successModal = false;

          });
      // bus.$on('show_spinner', (data) => {
      //   // alert(data);
      //   if(data== "true"){
      //     this.spinnerModal = true;
      //
      //   }else{
      //     this.spinnerModal = false;
      //   }
      // });
    },
    methods: {
      modal_close(){
        this.successModal = false
        bus.$emit("close_add_base_modal", 'true');

      },
      show_success_modal(title, text) {
        this.title = title;
        this.message_api = text;
        this.successModal = true;
      },

    }

  }
</script>
<style>
.modal-header {
  display: none;
}
</style>
